import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M9.6 7.2C8.28 7.2 7.2 8.28 7.2 9.6V14.4H2.4C1.08 14.4 0 15.48 0 16.8V21.6C0 22.92 1.08 24 2.4 24H21.6C22.92 24 24 22.92 24 21.6V16.8V14.4V9.6V7.2V2.4C24 1.08 22.92 0 21.6 0H16.8C15.48 0 14.4 1.068 14.4 2.4V7.2H9.6ZM7.2 16.8H9.6H21.6V20.4C21.6 21.06 21.06 21.6 20.4 21.6H3.6C2.94 21.6 2.4 21.06 2.4 20.4V18C2.4 17.34 2.94 16.8 3.6 16.8H7.2ZM14.4 9.6H16.8H21.6V14.4H9.6V10.8C9.6 10.14 10.14 9.6 10.8 9.6H14.4ZM18 2.4H20.4C21.06 2.4 21.6 2.94 21.6 3.6V7.2H16.8V3.6C16.8 2.94 17.34 2.4 18 2.4Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
